export function parseFontSize(fontSize) {
  return Math.ceil(parseFloat(fontSize.slice(0, -2)));
}
